/* @flow strict */

import * as React from 'react';
import Dropdown from './../dropdown';
import ResetPassModal from './../dialogs/resetPrassword';
import EditProfileModal from './../dialogs/editProfile';
import withMeta from '/client/src/HOCs/withMeta';
import Credentials from '/client/src/api/Credentials';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import './styles.scss';
import { ToggleOpacityOfContent } from '../../utils/animation';

type PropsType = {
  toggleAuthenticateStatus: () => void,
  isShowHeaderBanner: boolean,
  headerBannerContent: any,
  isOpenEditProfileModal: boolean
  // meta: MetaContextType
};

type StateType = {
  isOpenResetPassModal: boolean
};

class TopNavbar extends React.PureComponent<PropsType, StateType> {
  static contextType = DefaultContainerContext;

  state = {
    isOpenResetPassModal: false
  }

  handleToggleResetPassModal = (status: boolen) => {
    this.setState({
      isOpenResetPassModal: status
    });
  }

  render(): React.ElementType<'header'> {
    const { profileCurrent, handleToggleEditProfileModal } = this.context;
    const { isOpenResetPassModal } = this.state;
    const { isShowHeaderBanner, headerBannerContent, isOpenEditProfileModal } = this.props;

    const dropdownMenuItem = [
      {
        label: 'Edit profile',
        callback: () => {
          handleToggleEditProfileModal(true);
        }
      },
      {
        label: 'Reset password',
        callback: () => {
          this.handleToggleResetPassModal(true);
        }
      },
      {
        label: 'Logout',
        callback: async () => {
          ToggleOpacityOfContent(0);

          setTimeout(() => {
            Credentials.logout(true);
            this.context.setProfileCurrent(null);

            this.props.toggleAuthenticateStatus();

            window.localStorage.removeItem('SPARXO_filterEventDashboard');
          }, 500);
        }
      }
    ];

    return (
      <header className="sparxo-header">
        {
          isShowHeaderBanner &&
          <div className='header-banner'>
            {headerBannerContent}
          </div>
        }
        <div id="topNavBar" className="sparxo-navbar sparxo-navbar-white">
          <div className="sparxo-navbar-left" style={{ minWidth: '2rem' }} />

          <div className="sparxo-navbar-right">
            <div className="topNavBarActions" style={{ display: 'none' }} />
            <Dropdown
              selected={profileCurrent ? `${profileCurrent.first_name[0]}${profileCurrent.last_name[0] || ''}` : ''}
              email = {profileCurrent ?  profileCurrent.email : ''}
              className='Account'
              item={dropdownMenuItem}
              isLoading={!profileCurrent}
            />

            <ResetPassModal
              isOpen={isOpenResetPassModal}
              // eslint-disable-next-line
              handleToggleResetPassModal={this.handleToggleResetPassModal}
            />
            {isOpenEditProfileModal &&
              <EditProfileModal
                isOpen={isOpenEditProfileModal}
                // eslint-disable-next-line
                handleToggleEditProfileModal={this.handleToggleEditProfileModal}
              />
            }
          </div>
        </div>
      </header>
    );
  }
}

// const TopNavbar = ({ meta: metaContext }: PropsType): React.ComponentType => {
//   const dropdownMenuItem = [
//     {
//       label: 'Edit profile',
//       callback: () => {
//         handleToggleEditProfileModal(true);
//       }
//     },
//     {
//       label: 'Reset password',
//       callback: () => {
//         handleToggleResetPassModal(true);
//       }
//     },
//     {
//       label: 'Logout',
//       callback: async () => {
//         metaContext.setProfile(await GET('/auth/logout'));
//         localStorage.removeItem('profileId');
//         Credentials.logout();
//       }
//     }
//   ];
//   const [isOpenResetPassModal, handleToggleResetPassModal] = React.useState(false);
//   const [isOpenEditProfileModal, handleToggleEditProfileModal] = React.useState(false);
//
//   return (
//     <header className="sparxo-header">
//       <div id="topNavBar" className="sparxo-navbar sparxo-navbar-white">
//         <div className="sparxo-navbar-left" />
//
//         <div className="sparxo-navbar-right">
//           <div className="react-portal" />
//
//           <Dropdown
//             selected='AB'
//             className='Account'
//             item={dropdownMenuItem}
//           />
//
//           <ResetPassModal
//             isOpen={isOpenResetPassModal}
//             handleToggleResetPassModal={handleToggleResetPassModal}
//           />
//
//           <EditProfileModal
//             isOpen={isOpenEditProfileModal}
//             handleToggleEditProfileModal={handleToggleEditProfileModal}
//           />
//         </div>
//       </div>
//     </header>
//   );
// };

export default withMeta(TopNavbar);
